var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.types),function(type,index){return _c('vs-chip',{key:index,staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.typeColor(type)}},[_c('span',[_vm._v(_vm._s(_vm.typeText(type)))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }